<template>
  <svg
    class="checkmark"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
    :style="{ width: size, height: size }"
    role="img"
    aria-label="Done"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
</template>

<script setup lang="ts">
// Built-in checkmark shown when a progress-sequence item reaches 100%. Glyph
// matches ProgressBar's group-complete check. A subtle pop-in plays on mount
// (the moment the ring is replaced).
withDefaults(defineProps<{ size: string; color: string }>(), { size: '32px' })
</script>

<style scoped lang="scss">
.checkmark {
  display: block;
  flex-shrink: 0;
  animation: icon-list-check-pop 240ms cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes icon-list-check-pop {
  0% {
    transform: scale(0.4);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
